import { ProjectAdminStatistics } from '@/views/project-forum/models/ProjectForum';

const OFFER_STATUS_ORDER = [
  'ACCEPTED',
  'CONTRACTPROCESS',
  'NEGOTIATIONS',
  'OPEN',
  'OPEN_CHANGED',
  'WITHDRAWN',
  'WITHDRAWN_QUEUED',
  'DECLINED',
  'AUTO_REJECTED',
  'AUTO_REJECTED_QUEUED',
  'EXPIRED',
  'QUEUED',
];

export interface ProjectAdminInfoRow {
  labelKey: string;
  value: number | boolean | 'missing';
}

export const buildProjectAdminInfoRows = (
  adminStatistics?: ProjectAdminStatistics,
  acceptsOffers?: boolean,
): ProjectAdminInfoRow[] => {
  const countOffers = adminStatistics?.countOffers ?? {};
  const totalOffers = Object.values(countOffers)
    .reduce((total, count) => total + count, 0);
  const knownStatuses = new Set(OFFER_STATUS_ORDER);
  const visibleStatuses = Object.entries(countOffers)
    .filter(([, count]) => count > 0);
  const statusRows = [
    ...OFFER_STATUS_ORDER
      .filter((status) => (countOffers[status] ?? 0) > 0)
      .map((status) => [status, countOffers[status]] as const),
    ...visibleStatuses.filter(([status]) => !knownStatuses.has(status)),
  ]
    .map(([status, count]) => ({ labelKey: `statuses.${status}`, value: count }));

  return [
    { labelKey: 'offers', value: totalOffers },
    { labelKey: 'contracts', value: adminStatistics?.contractCount ?? 0 },
    {
      labelKey: 'queue-full',
      value: typeof acceptsOffers === 'boolean' ? !acceptsOffers : 'missing'
    },
    ...statusRows,
  ];
};
